import PageLayout from "../../hocs/PageLayout";
import Analytics from "./containers";

export const analyticsRoutes =[
    {
        path:'/analytics-graph',
        component:PageLayout(Analytics, {apps: 'analytics', layoutPhase: 1} ),
        key: 'Analytics',
    }
]